import React from 'react';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import Header from './Global/Header';
import Banner from './Homepage.js/Banner';
import Latest from './Homepage.js/Latest';
import Sellers from './Homepage.js/Sellers';
import Content from './Homepage.js/Content';
//import Collectibles from './Collectibles';
// import CollectibleListing from './CollectibleListing';
import Footer from './Global/Footer';
import Collectible from './Homepage.js/Collectible';


function Landing(){

return(

    <>
<div class="main">
    <div class="home home--hero">
        <Header />
		<Banner />
		<Latest />
		<Sellers />
		<Content />
		<Collectible />
		
		</div>
		</div>

        <Footer />
	
    </>
    
    );
    
    
    }
    
    export default Landing;